import React, { useEffect, useState } from 'react';

// DEPENDENCIES
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE } from 'pathnames.js';
import { SORT_ORDER } from 'globals.js';

// LOCAL VARIABLES
import { ACTIONS, COLUMNS } from '../../../../columns.js';

// GLOBAL HELPERS
import { getListData } from 'helpers/getListData';
import { recountActions } from 'actions.js';

// GLOBAL COMPONENTS
import Alert from 'core/tools/alert/Alert';
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table.js';
import Title from 'parts/title/Title';

// LOCAL COMPONENTS
import ExcelButtons from '../../tools/ExcelButtons';

// MAIN COMPONENT
const AMFinance = () => {
  // REACT ROUTER
  const navigate = useNavigate();
  const location = useLocation();

  // REDUX
  const dispatch = useDispatch();

  // STATE
  const [statusMessage, setStatusMessage] = useState();

  // EFFECTS
  useEffect(() => {
    if (location?.state?.statusMessage) {
      setStatusMessage(location.state.statusMessage);

      // After setting status message, clear state
      navigate({ ...location, state: {} }, { replace: true });
    }

    dispatch(recountActions.toggle());
  }, [dispatch, location, navigate]);

  // RENDER
  return (
    <Main>
      <Title documentTitle="AM/Finance " title="AM/Finance" tools={<ExcelButtons fileName="am_finance" />} />
      <Filters>
        <Filters.Button.SalesType />
        <Filters.Button.NewUsed />
      </Filters>
      {statusMessage ? (
        <Alert.Dismissable variant="primary" message={statusMessage} onClose={() => setStatusMessage(null)} />
      ) : null}
      <Table.Sorted
        sortParam="sales_date"
        defaultKey={false}
        titleFormat={date =>
          new Date(date).toLocaleDateString('en-us', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })
        }
        mobilePreviewKeys={['customer1_full_name', 'make_model', 'stock_num']}
      />
    </Main>
  );
};

// EXPORT
export default getListData(AMFinance, {
  key: 'amFinance',
  fetchArgs: {
    endpoint: ENDPOINTS.amFinance.list
  },
  defaults: {
    sort: 'sales_time',
    order: SORT_ORDER.descending,
    startRow: null
  },
  columns: [
    {
      key: 'nextInQueue',
      icon: 'info',
      tooltip: 'Next In Queue',
      codes: {
        n: {
          icon: 'next-in-queue',
          className: 'text-highlight',
          label: 'Next Deal in Queue'
        }
      },
      width: 30,
      component: Table.Code
    },
    COLUMNS.salesTime,
    COLUMNS.salesStatus,
    COLUMNS.salesPerson,
    COLUMNS.customer(INTERFACE.amFinance),
    COLUMNS.ageOfVehicle,
    COLUMNS.newUsed,
    COLUMNS.saleSubtype,
    {
      ...COLUMNS.purchaseLease,
      width: 35
    },
    {
      ...COLUMNS.retailWholesale,
      key: 'sale_type_category_code',
      width: 35
    },
    COLUMNS.stockNumber,
    COLUMNS.makeModel,
    COLUMNS.trades,
    COLUMNS.frontendGross,
    COLUMNS.amAssignment,
    COLUMNS.amTime,
    COLUMNS.amStatus,
    COLUMNS.fmAssignment,
    COLUMNS.fmTime,
    COLUMNS.fmStatus,
    COLUMNS.sa1,
    COLUMNS.sa2,
    COLUMNS.sa3
  ],
  actions: [ACTIONS.open(INTERFACE.amFinance, 'sales_id')]
});
